export default "__VITE_ASSET__BnfLLa5D__"